var React = require('react');

function OrangePlayButton (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M88.0646 42.705C92.302 44.9633 92.302 51.0367 88.0645 53.295L9.3219 95.26C5.32532 97.3899 0.499995 94.4937 0.499996 89.965L0.499999 6.03499C0.499999 1.50628 5.32533 -1.38993 9.3219 0.740005L88.0646 42.705Z","fill":"#FF6B36"}));
}

OrangePlayButton.defaultProps = {"width":"92","height":"96","viewBox":"0 0 92 96","fill":"none"};

module.exports = OrangePlayButton;

OrangePlayButton.default = OrangePlayButton;
